import { makeObservable, observable, action } from 'mobx';
import { RootStore } from './Root.store';

export enum tabs {
    monitoring = 'monitoring',
    control = 'control',
    options = 'options',
}

export type tab = `${tabs}`;

export default class SidebarStore {
    @observable
    public tab: tab;

    @observable
    public isSidebarHidden: boolean;

    constructor(private rootStore: RootStore) {
        this.setDefault();
        makeObservable(this);
    }

    @action
    setDefault() {
        this.tab = 'monitoring';
        this.isSidebarHidden = false;
    }

    @action
    setTab(tab: string) {
        if (tab in tabs) {
            this.tab = tab as tab;
        }
    }

    @action
    hideSideBar() {
        this.isSidebarHidden = true;
    }

    @action
    showSideBar() {
        this.isSidebarHidden = false;
    }

    @action
    toggleSideBar() {
        this.isSidebarHidden = !this.isSidebarHidden;
    }
}
